export default "__VITE_ASSET__CsZ_s1jI__"